import { render, staticRenderFns } from "./SeeMoreButton.vue?vue&type=template&id=4c9fe33c&scoped=true"
import script from "./SeeMoreButton.vue?vue&type=script&lang=js"
export * from "./SeeMoreButton.vue?vue&type=script&lang=js"
import style0 from "./SeeMoreButton.vue?vue&type=style&index=0&id=4c9fe33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9fe33c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SecondaryLoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/SecondaryLoadingSpinner.vue').default})
